import React from "react";
import "./Footer.css";

export default function Footer() {
  const date = new Date(Date.now());

  return (
    <footer>
      <p>Copyright © {date.getFullYear()} David Hollins</p>
    </footer>
  );
}
